import { FC } from 'react';
import { Button, Grid } from '@mui/material';
import { observer } from 'mobx-react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import BaseConfig from './BaseConfig';

interface SwishConfigProps {
  onClose: () => void;
}

const SwishConfig: FC<SwishConfigProps> = observer(({ onClose }) => {
  return (
    <BaseConfig
      title="Swish via Enklakassan"
      description="Enklakassan har förhandlat fram ett Swish avtal där kunen kan använda Swish handel för endast 1,75kr/transaktion och 59kr/månaden. Med Swish Handel blir alla transaktioner säkra, då kassan verifierar om transaktionen går igenom. Dessutom samlas alla utbetalningar till 1 gång om dagen vilket underlättar bokföringen."
      price="1.75 kr/transaktion, 59kr/mån"
      onClose={onClose}
      onSubmit={() => {}}
      buttons={
        <Button variant="outlined" onClick={onClose} color="secondary">
          Avbryt
        </Button>
      }
    >
      <Grid item xs={12}>
        <Button
          variant="contained"
          color="secondary"
          href="http://northmill.com/se/foretag/app/partner/login?services=swishhandel&code=ENKLA25"
          target="_blank"
          rel="noopener noreferrer"
          endIcon={<OpenInNewIcon />}
        >
          Aktivera Swish via Enklakassan
        </Button>
      </Grid>
    </BaseConfig>
  );
});

export default SwishConfig;
